<template>
    <div v-if="data != null" id="container-new" class="w-full">
        <div id="subcontainer-new" class="w-1/2 mx-auto max-md:w-full max-md:px-special max-md:pt-special">
            <div id="title-new" class="w-full text-left">
                <span class="font-bloggerB text-big-text-news-desktop dark:text-primary-dark-text">
                    {{ data['name'] }}
                </span>
            </div>
            <div id="container-photo" class="relative overflow-hidden w-full mx-auto aspect-video mt-special">
                <img :src="data['url']" :alt="'IMAGEN DE ' + data['name']" class="w-full h-full">
            </div>
            <span class="text-ticket-desktop font-monserratR text-gray-text dark:text-primary-dark-text max-md:text-ticket-mobile">{{ data['reserves'] }}</span>
            <div id="data-date-ticket" class="mt-special text-label-desktop font-monserratR text-gray-text dark:text-gray-lite max-md:text-label-mobile">
                <span class="pl-special">
                    Por <span class="font-monserratM">{{ data['author'] }}</span>
                </span>
                <span class="flex mt-text pl-special">
                    {{ date }}
                </span>
            </div>
            <div id="content" class="mt-special px-special">
                <pre class="w-full text-wrap font-monserratM text-button-desktop leading-5 text-justify max-md:text-content-mobile dark:text-primary-dark-text" v-html="data['content']"></pre>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref, effectScope, computed } from 'vue';
import { newStore } from '@/stores/news';
import { generalStore } from '@/stores';
import { useHead, useSeoMeta } from '@unhead/vue';


const storeN = newStore();
const store = generalStore();
const route = store.route;

store.setIsPP(false)
var data = ref([])
var date = ref('')

onMounted(() => {
    store.setSubMenu(null);
})

useSeoMeta({
  // Basic SEO
  title: route.params.name,
  description: computed(() => data.value != null ? data.value['name'] : ''),

  // Open Graph
  ogTitle: route.params.name,
  ogDescription: computed(() => data.value != null ? data.value['name'] : ''),
  ogImage: computed(() => data.value != null ? data.value['url'] : ''),
  ogUrl: 'https://www.ccjmedios.com',
  ogType: 'Article',
  ogSiteName: 'www.ccjmedios.com',
})


useHead({
    link: [{
        rel: 'canonical',
        href: window.location.href
    }]
})

onBeforeMount(async () => {
    data.value = storeN.getDetailNew();
    if (data.value == null) {
        data.value = (await storeN.getCompleteNews(route.params.id))[0];
    }
    date.value = new Date(data.value['date']).toLocaleDateString('es-es', { weekday: "long", year: "numeric", month: "long", day: "numeric" });
})
</script>